module.exports = __webpack_public_path__ + "static/media/EST-FTM.3bf8eead.png";